import { useEffect, useState } from 'react';
import { getCategoryListAPI, getProductAPI } from '../api/AccountSetup';

const getCustomProductEffect = (uuid: string) => {
  const [product, setProduct] = useState<string[]>([]);

  const fetchData = async () => {
    try {
      const res = await getProductAPI(uuid);
      setProduct(
        res.payload.result.map((data: any) => ({
          uuid: data.uuid,
          productName: data.foodName,
          price: data.price,
          desc: data.description,
          category: data.foodCategory
        }))
      );
    } catch (error) {
      console.error('Error fetching menu:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { product, fetchData };
};

const getProductCategoryEffect = () => {
  const [categoryList, setCategoryList] = useState<string[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getCategoryListAPI();
        setCategoryList(res.payload);
      } catch (error) {
        console.error('Error fetching menu:', error);
      }
    };
    fetchData();
  }, []);

  return { categoryList };
};

export { getCustomProductEffect, getProductCategoryEffect };
